import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { UserContext } from "App";
import { useContext } from "react";
import AccountingApi from "../../Classes/API/AccountingApi";
import SearchStringOrIntReq from "../../Classes/Models/Requests/SearchStringOrIntReq";
import Loader from "Loader";
import Swal from "sweetalert2";

function Notifications() {
 
  const User = useContext(UserContext);
  const [Notifications, setNotifications] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [PageNumber, setPageNumber] = useState(1);
 
  const alertContent = (message) => (
    <MDTypography variant="body2" color="white" fontWeight="medium">
      {message}
    </MDTypography>
  );

  useEffect(() => {
    if(Object.keys(Notifications).length > 0 ){
      setIsLoaded(true);
    }
    else{
      setIsLoaded(false);
    }
    console.log("loaded", IsLoaded);
  }, [Notifications]);

  useEffect(() => {
    if(!IsLoaded){
      GetNotifications();
    }
  }, [IsLoaded]);

  useEffect(() => {
    GetNotifications();
  }, [PageNumber]);


  const GetNotifications = async () => {
    const req = new SearchStringOrIntReq();
    req.SearchInt = PageNumber;
    console.log("req", req);
    const res = await AccountingApi.GetUserNotifications(req);
    console.log("Notifications", res);
    if (res.status == "Success") {
      setNotifications(res.data);
    }
    else{
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });

    }
  };


  if(!IsLoaded){
    return <Loader color="black"/>
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>

        <MDBox p={2}>
          <MDTypography variant="h5">Alerts</MDTypography>
          <div style={{margin: "1em"}}>
            {
              PageNumber > 1 &&
              <button className="btn btn-primary mr-3" onClick={() => setPageNumber(PageNumber - 1)}>Previous</button>
            }
            <button className="btn btn-primary" onClick={() => setPageNumber(PageNumber + 1)}>Next</button>
          </div>
        </MDBox>
        <MDBox pt={2} px={2}>
          {
            Notifications.list.map((item) => (
              <MDAlert
                key={item.id}
                color="secondary"
              >
                {alertContent(item.getNotification.message)}
              </MDAlert>
            ))
          }
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Notifications;
